import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export function getPrepLessonsDetails(courseId: number, lessonIds: Array<number>) {
    const { apiGetPrepLessonsDetails } = apiConfig.getStaticUrls();

    return getFetch(apiGetPrepLessonsDetails, { course_id: courseId, lesson_ids: lessonIds.join(',') });
}
